/*
 * Essential imports
 */

import Alpine from 'alpinejs';
import 'picturefill';
import 'lazysizes';

/*
 * Essential fixes
 */

// Preload and No-JS
setTimeout(() => {
  document.documentElement.classList.remove('preload');
  document.documentElement.classList.remove('no-js');
}, 300);

let resizeId;

window.addEventListener('resize', () => {
  clearTimeout(resizeId);
  document.documentElement.classList.add('preload');
  resizeId = setTimeout(() => {
    document.documentElement.classList.remove('preload');
  }, 300);
});

// Fix NodeList.forEach in IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/*
 * Function imports
 */

import { INIT_accordion } from './functions/accordion';
import { INIT_cart } from './functions/cart';
import { INIT_configurator } from './functions/configurator';
import { INIT_forms } from './functions/forms';
import { INIT_goTo } from './functions/goto';
import { INIT_inputQuantity } from './functions/input-quantity';
import { INIT_modals } from './functions/modals';
import { INIT_portal } from './functions/portal';
import { INIT_tooltip } from './functions/tooltip';
import { INIT_contractor } from './functions/contractor';
import { INIT_customer_portal } from './functions/customer-portal';
import { INIT_terms } from './functions/terms';

INIT_accordion();
INIT_cart();
INIT_configurator();
INIT_forms();
INIT_goTo();
INIT_inputQuantity();
INIT_modals();
INIT_portal();
INIT_tooltip();
INIT_contractor();
INIT_customer_portal();
INIT_terms();

Alpine.start();

/*
 * FlashMessage
 */

import { FlashMessage } from './grit-form-handler';
export const msg = new FlashMessage('#flash-message', 7200);

/*
 * Polyfills
 */

import { INIT_polyfillHas } from './functions/polyfill-has';
INIT_polyfillHas();
